export default __webpack_public_path__ + "static/media/gallery_02.da2d8a1f.jpg";